"use strict"; function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _store = require('shared/store');
var _client = require('shared/services/client'); var _client2 = _interopRequireDefault(_client);
var _bus = require('shared/services/bus'); var _bus2 = _interopRequireDefault(_bus);
var _actions = require('shared/actions'); var _actions2 = _interopRequireDefault(_actions);
var _actionCreators = require('shared/actions/actionCreators'); var _actionCreators2 = _interopRequireDefault(_actionCreators);
var _alertReducer = require('shared/reducers/alertReducer');
var _upgrade = require('shared/services/upgrade');
var _broadcast = require('shared/selectors/broadcast');
var _campaignRecipientsAdds = require('shared/selectors/campaignRecipientsAdds');
var _campaignRecipientsAdd = require('shared/services/campaignRecipientsAdd');
var _time = require('shared/services/time');
var _peers = require('shared/selectors/peers');

var _events = require('shared/services/forms/events');


/* The notification payload each handler takes; the socket delivers `Data`
 * untyped, so each case narrows it to its handler's parameter. */














const loadingUserKeys = new Set()
const leftOutUsers = new Set()
const leftOutKey = (chatKey, userKey) => `${chatKey}:${userKey}`
function loadNewSubscriberUsers (update) {
  const users = _peers.selectAllCombinedUsers.call(void 0, _store.getState.call(void 0, ))
  for (const [chatKey, chat] of Object.entries(_nullishCoalesce(update.Blobjects, () => ( {})))) {
    const missing = Object.keys(_nullishCoalesce(chat.UserSubscribers, () => ( {})))
      // SAFETY: UserSubscribers is keyed by user key; a key we lack reads undefined.
      .filter(key => !users[key ] && !loadingUserKeys.has(key))
      .filter(key => !leftOutUsers.has(leftOutKey(chatKey, key)))
    if (!missing.length) continue
    missing.forEach(key => loadingUserKeys.add(key))
    // SAFETY: the server keys Update.Blobjects by blobject key and each
    // chat's UserSubscribers by user key.
    const request = { UserKeys: missing , BKey: chatKey  }
    _actions2.default.getUsers(request)
      .then(response => missing
        .filter(key => !Object.hasOwn(_nullishCoalesce(_optionalChain([response, 'optionalAccess', _ => _.Users]), () => ( {})), key))
        .forEach(key => leftOutUsers.add(leftOutKey(chatKey, key))))
      .catch(e => log.error(e ))
      .finally(() => missing.forEach(key => loadingUserKeys.delete(key)))
  }
}






function handleInbound (message) {
  try {
    switch (message.Command) {
      case 'Update': {
        const data = message.Data 
        _actions2.default.handleUpdateNotification(data)
        loadNewSubscriberUsers(data)
        break
      }
      case 'Purge': _actions2.default.handlePurgeNotification(message.Data ); break
      case 'Toast': _actions2.default.handleToastNotification(message.Data ); break
      case 'ClientUpgradeNotification':
        return message.Data && _upgrade.handleUpgrade.call(void 0, message.Data )
      case 'ExportChatCompleteNotification':
        return _actions2.default.handleExportChatCompleteNotification(
          message.Data ,
        )
      case 'ExportPhoneLogsCompleteNotification':
        return _actions2.default.handleExportPhoneLogsCompleteNotification(
          message.Data ,
        )
      case 'PatientImportCompleteNotification':
        return _actions2.default.handlePatientImportCompleteNotification(
          message.Data ,
        )
      case 'UpdateOrgUsers':
        return _actions2.default.handleUpdateOrgUsersNotification(
          message.Data ,
        )
      case 'OrgFeaturesChangedNotification':
        _actions2.default.handleOrgFeaturesChangedNotification(
          message.Data ,
        )
        // KEYWORDS may have come or gone with it.
        _actions2.default.loadOpenRequests()
        return
      case 'OrgPatientAppChangedNotification':
        return _actions2.default.handleOrgPatientAppChangedNotification(
          message.Data ,
        )
      case 'ScheduledMessageUpdate':
        return _actions2.default.handleScheduledMessageUpdate(
          message.Data ,
        )
      case 'ConversationTranslationChanged':
        return _actions2.default.handleConversationTranslationChanged(
          message.Data ,
        )
      case 'CampaignProgressNotification': {
        const data = message.Data 
        const state = _store.getState.call(void 0, )
        const c = _broadcast.selectCampaignByKey.call(void 0, state, data.CampaignKey)
        if (!c || _time.isAfter.call(void 0, c.RefreshedAt, data.RefreshedAt)) return
        return _actions2.default.handleCampaignProgressNotification(data)
      }
      case 'CampaignRecipientsAddNotification': {
        const data = message.Data 
        const state = _store.getState.call(void 0, )
        const before = _campaignRecipientsAdds.selectCampaignRecipientsAdd.call(void 0, state, data.CampaignKey)
        _actions2.default.handleCampaignRecipientsAddNotification(data)
        // P2': an Add declares the file's variables when it starts and
        // changes the campaign's recipients: a loaded campaign is read again
        // when one starts or ends (chunk progress comes as Stats pushes).
        if (_campaignRecipientsAdd.isNewAddState.call(void 0, before, data) && _broadcast.selectCampaignByKey.call(void 0, state, data.CampaignKey)) {
          _actions2.default.getCampaign(data.CampaignKey).catch(() => undefined)
        }
        return
      }
      case 'CampaignRecipientsAddCompleteNotification':
        // Only the starter's connections get it; the web shows its notice.
        return _actions2.default.handleCampaignRecipientsAddCompleteNotification(
          message.Data ,
        )
      case 'Connected': {
        const data = message.Data 
        const state = _store.getState.call(void 0, )
        // Requests opened or handled while the socket was down.
        _actions2.default.loadOpenRequests()
        // Who the caller can reach may have changed while the socket was down.
        leftOutUsers.clear()
        return _store.dispatch.call(void 0, {
          type: 'SERVER_ACK_SOCKET_CONNECTED',
          userInfo: state.currentUser,
          buildConfig: _upgrade.getActiveBuildConfig.call(void 0, data.BuildConfig),
          currentVersion: VERSION,
          mobilePushToken: data.MobilePushToken,
        })
      }
      case 'FormChanged':
        return _events.emitFormChanged.call(void 0, message.Data )
      case 'IncomingMessageNotification': // only updates `state.chats`
      case 'IncomingChatReadNotification': // updates some ancient state slices
      case 'ChatNameNotification': // is handled by `Update`
      case 'ChatStatusChangeNotification': // some more fossil
      case 'UserUpdatedNotification': // not triggered?
      case 'PatientConversationCompletedChange': // not triggered?
      case 'GenericClientNotification':
        // A request opened or was handled on one of my teams. Other bodies
        // (old user toasts) stay ignored.
        if (_optionalChain([(message.Data ), 'optionalAccess', _2 => _2.Type]) === 'todos') _actions2.default.loadOpenRequests()
        return
      case 'IncomingPatientMessage':
        return
      default:
        if (
          message.Command !== 'AuthInfo' &&
          !message.Command.startsWith('VideoRoom')
        ) log.error(`Handling of command '${message.Command}' not yet implemented`)
    }
  // log.error receives whatever was thrown, as in the JS.
  } catch (e) { log.error(e ) }
}

function handleSessionExpired () {
  // No need to close client as this event implies its already been closed
  _store.dispatch.call(void 0, { type: 'SESSION_EXPIRED' })
  _actions2.default.logout()
}

function handleSocketConnected () {
  _store.dispatch.call(void 0, { type: 'SOCKET_CONNECTED' })
}

function handleSocketDisconnected () {
  _store.dispatch.call(void 0, { type: 'SOCKET_DISCONNECTED' })
}

function handleSocketClosed () {
  _store.dispatch.call(void 0, { type: 'SOCKET_DISCONNECTED' })
  _store.dispatch.call(void 0, { type: 'CLIENT_CLOSED' })
}

function handleClientFreakout () {
  if (location) {
    location.reload()
  }
}

function setClientEventHandlers () {
  _client2.default.off()
  _client2.default.on('inbound', handleInbound)
  _client2.default.on('session-expired', handleSessionExpired)
  _client2.default.on('open', handleSocketConnected)
  _client2.default.on('closed', handleSocketClosed)
  _client2.default.on('unexpected-closed', handleSocketDisconnected)
  _client2.default.on('freakout', handleClientFreakout)

  _actions2.default.assumeGoodInitialConnectionMS(2000)
}

_bus2.default.on(_actionCreators2.default.loginSuccessAction.type, action => {
  // loginSuccessAction's payload type (ChatPreload + User + UserInfo) does
  // not declare CSRF; it is read from the payload as in the JS.
  _client2.default.open({ token: (action.payload ).CSRF })

  _store.dispatch.call(void 0, { type: 'CLIENT_OPENED' })

  setClientEventHandlers()
})

_bus2.default.on(_actionCreators2.default.logoutAction.type, () => {
  _client2.default.off()
  _client2.default.close()
  _client2.default.logout().catch(
    () => _actions2.default.pushAlert('Error', "Couldn't log out", _alertReducer.AlertTypes.ERROR),
  )
})

_bus2.default.on(_actionCreators2.default.unAuthenticatedConnectAction.type, (action) => {
  // Pre-existing: OpenCfg has no patientCode, so open() ignores it (and
  // nothing dispatches this action today). Kept as-is; the cast only lets
  // TypeScript accept the unknown key.
  _client2.default.open({ patientCode: (action.payload ).patientCode } )

  setClientEventHandlers()
})

_client2.default.on('inbound', handleInbound)
